<template>
  <div class="no-delete-box">
    <p>{{ text }}</p>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'NoDeleteBox',
  props: {
    text: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.no-delete-box {
  color: $main-background;
  background: $warning;
  padding: $content-padding;

  p {
    margin-bottom: 1rem;
  }

  a {
    text-decoration: underline;
    color: $main-background;
    font-weight: bold;
  }
}
</style>
